// Auto-generated by contracts/scripts/export-abis.ts — do not edit by hand.
// Canonical CREATE2 addresses via the Arachnid factory
// (0x4e59b44847b379578588920cA78FbF26c0B4956C) with the default DEPLOY_SALT.
// Deploying with the same salt + same bytecode on any chain that has the
// Arachnid factory pre-deployed yields these exact addresses.

import type { Address } from "viem";

export const CANONICAL_ADDRESSES: {
  factory: Address;
  dropImpl: Address;
  simpleImpl: Address;
  badgeImpl: Address;
  atelier1of1: Address;
} = {
  factory: "0xd9cc967f995Cd290Ba328e6EE8b5b4a74ca67fa6",
  dropImpl: "0x24C889F72B9842e61e8bffAf5bFdb8ED6e6B7513",
  simpleImpl: "0x611a222B087f76181130906EaDbFd4bbB86103f1",
  badgeImpl: "0x5d7a3d4435bb801927081C4e2310aB71118d8F0B",
  atelier1of1: "0x7caC0C897cFFc86c558486E989522A3557D73c4C",
};

export const ARACHNID_FACTORY: Address = "0x4e59b44847b379578588920cA78FbF26c0B4956C";

export const DEFAULT_DEPLOY_SALT =
  "0x00000000000000000000000000000000000000000000617465c3a96c69657201" as `0x${string}`;
